import { render, staticRenderFns } from "./QuestionSet.vue?vue&type=template&id=f4fa0e7c"
import script from "./QuestionSet.vue?vue&type=script&lang=js"
export * from "./QuestionSet.vue?vue&type=script&lang=js"
import style0 from "./QuestionSet.vue?vue&type=style&index=0&id=f4fa0e7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports